import { Address } from '@grubhubprod/order-taking-client-sdk/dist/sdk/types/geocode';
import { FormFields } from 'src/components/enterprise/features/Locations/ManageLocation/LocationForm';

export function getFieldValue(
  suggestedAddress: Partial<Address>,
  fields: Partial<FormFields>,
  fieldName: keyof Address & keyof FormFields,
  fallbackFieldName?: keyof Address & keyof FormFields
): string {
  return (
    suggestedAddress?.[fieldName] ||
    suggestedAddress?.[fallbackFieldName] ||
    fields[fieldName]
  );
}
